import { Body, Controller, Post, UploadedFile, UseInterceptors } from '@nestjs/common';
import { FileInterceptor } from '@nestjs/platform-express';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { CommonResponseModel } from '@project-management-system/shared-models';
import * as fs from 'fs';
import { diskStorage } from 'multer';
import { extname, join } from "path";
import { VardhamanService } from './vardhaman.service';

@Controller('vardhaman')
export class VardhamanController {
    constructor(
        private VardhamanService: VardhamanService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ) { }

    @Post('pdf-extraction')
    @UseInterceptors(FileInterceptor('file'))
    async pdfExtraction(@UploadedFile() file: Express.Multer.File) {
        if (!file) {
            throw new Error('No file uploaded');
        }

        if (file.mimetype !== 'application/pdf') {
            throw new Error('Only PDF files are allowed');
        }

        const textContent = await this.VardhamanService.pdfExtraction(file);
        return { text: textContent };
    }

    @Post("/savePdfExtractedData")
    @UseInterceptors(FileInterceptor('file', {
        storage: diskStorage({
            destination: (req, file, callback) => {
                const destinationPath = join(__dirname, '../../../../', 'upload_files');
                try {
                    fs.mkdirSync(destinationPath, { recursive: true });
                    callback(null, destinationPath);
                } catch (error) {
                    callback(error, null);
                }
            },
            filename: (req, file, callback) => {
                const name = file.originalname.split('.')[0];
                const fileExtName = extname(file.originalname);
                const randomName = Array(4).fill(null).map(() => Math.round(Math.random() * 16).toString(16)).join('');
                callback(null, `${name}-${randomName}${fileExtName}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(xlsx|xls|pdf|jpg|png|jpeg|doc|PDF)$/)) {
                return callback(new Error('Only xlsx,xls,pdf,jpg,png,doc,jpeg files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async savePdfExtractedData(
        @UploadedFile() file: Express.Multer.File,
        @Body() body: any
    ): Promise<CommonResponseModel> {
        try {
            const jsonData = JSON.parse(body.jsonData);
            const req = {
                jsonData: jsonData,
                summary: body.summaryData,
                file: { originalname: file.originalname, filename: file.filename, path: file.path }
            };
            return this.VardhamanService.savePdfExtractedData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getPdfInfoDetailedViewData')
    async getPdfInfoDetailedViewData(): Promise<CommonResponseModel> {
        try {
            return await this.VardhamanService.getPdfInfoDetailedViewData()
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error)
        }
    }

    @Post('/getAllData')
    async getAllData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.VardhamanService.getAllData(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error)
        }
    }

    @Post('/createFeildMapping')
    async createFeildMapping(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.VardhamanService.createFeildMapping(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error)
        }
    }
    @Post('/getFeildMappingData')
    async getFeildMappingData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.VardhamanService.getFeildMappingData()
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error)
        }
    }
 
    @Post('/chatGptBot')
    async chatGptBot(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.VardhamanService.chatGptBot(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error)
        }
    }


}
